import { UnionMap } from '../types/union-map';

export type SkuType = 'Classic' | 'Harstine';

export const SkuType: UnionMap<SkuType> = {
    Classic: 'Classic',
    Harstine: 'Harstine',
};

export const ProjectHarstineTag = 'internal-licensing-sku';
